module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAbCAYAAAAH+20UAAAA6UlEQVRYR+2XsQ3CMBBF/yUFSK4TIWASVqCjJQxAkwFoskOSArEDBRQwBmOwAiLIh2wFRJCoIiNbuutc+PT07ssnEwAURTFM03QJYGrOvhUzN1rrc57nFzJwVVXtiWjhG+gnDzPf4zieWeC6rm8ABj4Dt2ybMA2bDCdJkhHRxEfLWusHM5/eGfYR8heTjURIJcCupyWG/2JYVrMDzbKaHUjttOwYltXsULe8ww7l2tZiWAx/GbCRKMtyHkXR1tdfM4AGwEEptXp9Qq8ARq7H2bc/M6/DBG4jsQMw7mvB0X0TiaNSKgvuWXsCJS9oZmMf+l8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/menu.png
// module id = 4iLE
// module chunks = 0